import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * DesktopPhonePill — PC GNB 우측 영역 (v2 목업 .gnb: 검색 · 전화 CTA · 로그인).
 *
 * 모바일: hidden — 하단 탭바·sticky CTA 가 대체
 * md+: 로그인(비로그인) / 마이 · 로그아웃(로그인) — 카카오 아이디(kakao_…)가 로그인 표시로 안 읽혀 2026-10-01 교체
 * lg+: 검색 pill(280px)
 *   - 검색은 자체 검색창이 있는 홈(/)·지도(/map)·분양목록(/list)에서는 숨김
 *   - 제출 시 /list?search=… 로 이동
 *
 * 전화번호: PC 헤더에서는 표시하지 않는다(대표 지시 2026-09-22). 전화는 상세 CTA 에서만.
 */

const SearchIcon: React.FC = () => (
  <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

const OWN_SEARCH_PATHS = ['/', '/map', '/list'];

export const DesktopPhonePill: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const showSearch = !OWN_SEARCH_PATHS.includes(pathname);

  return (
    <div className={`hidden md:flex md:items-center md:gap-4 ${className}`}>
      {showSearch && (
        <form
          role="search"
          onSubmit={(e) => {
            e.preventDefault();
            const v = q.trim();
            navigate(v ? `/list?search=${encodeURIComponent(v)}` : '/list');
            setQ('');
          }}
          className="hidden h-10 w-[280px] items-center gap-1.5 rounded-ca-xl bg-ca-surface px-3 text-muted lg:flex"
        >
          <SearchIcon />
          <input
            type="search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="단지명 · 동 · 지하철역"
            aria-label="단지 검색"
            className="min-w-0 flex-1 bg-transparent text-[13px] text-ink placeholder:text-mute2 outline-none"
          />
        </form>
      )}
      {user ? (
        <span className="flex items-center gap-3 whitespace-nowrap text-[14px] font-semibold text-body">
          <Link to="/profile" className="hover:text-ink">
            마이
          </Link>
          <button
            type="button"
            onClick={() => {
              logout();
              navigate(pathname, { replace: true });
            }}
            className="text-muted hover:text-ink"
          >
            로그아웃
          </button>
        </span>
      ) : (
        <Link to="/login" className="whitespace-nowrap text-[14px] font-semibold text-body hover:text-ink">
          로그인
        </Link>
      )}
    </div>
  );
};

export default DesktopPhonePill;
